/*=========================================================================================
  File Name: gameMutation.js
  Description: game Module Mutations
==========================================================================================*/

export default {
  SET_MEMBER(state, member) {
    state.member = member;
  },
  SET_GAME(state, game) {
    state.game = game;
  },
  SET_LOBBY_VIEW(state, lobbyRoomDisplay) {
    state.settings.lobbyRoomDisplay = lobbyRoomDisplay;
  },
  SET_CANCEL_TIME(state, cancelTime) {
    state.settings.cancelTime = cancelTime;
  },
  SET_ALLOW_CROSS_BETTING(state, crossBets) {
    state.settings.crossBets = crossBets === "1" ? true : false
  },
  SET_CANCEL_TYPE(state, cancelType) {
    state.settings.cancelType = cancelType;
  },
  SET_MAX_GAMEROUND_KICK(state, maxRoundRoomKick) {
    state.settings.maxRoundRoomKick = maxRoundRoomKick;
  },
  SET_SHOW_FIREWORKS(state, showFireworks) {
    state.settings.showFireworks = showFireworks;
  },
  SET_VIDEO_TEXT_KR(state, videoTextKr) {
    state.settings.videoTextKr = videoTextKr;
  },
  SET_VIDEO_TEXT_CN(state, videoTextCn) {
    state.settings.videoTextCn = videoTextCn;
  },
  SET_VIDEO_TEXT_EN(state, videoTextEn) {
    state.settings.videoTextEn = videoTextEn;
  },
  SET_BALANCE(state, balance) {
    state.member.balance = balance;
  },
  SET_PREV_BALANCE(state, prevbalance) {
    state.member.prevBalance = prevbalance;
  },

  SET_PREV_ROOM(state, prevRoom) {
    state.member.prevRoom = prevRoom;
  },

  SET_LEVELS(state, level) {
    state.levels = level;
  },
  SET_CURRENT_LEVEL(state, level) {
    state.currentLevel = level;
  },

  SET_VIDEO(state, video) {
    state.video = video;
  },
  SET_LOBBY_ROOM_DATA(state, data) {
    try {
      const roomIdx = state.game.rooms.findIndex(
        (r) => r.roomno === data.roomno
      );
      state.game.rooms[roomIdx].shoe = data.shoe;
      state.game.rooms[roomIdx].roomorder = data.roomorder;
      state.game.rooms[roomIdx].timer = data.timer || 0;
      state.game.rooms[roomIdx].timerdate = data.date || '';

    } catch (e) {
      return false;
    }
  },
  SET_ROOM_DATA(state, data) {
    try {

      // prevent mutation if same data as previous
      if(state.currentRoom.roomno === data.roomno && state.currentRoom.roomorder === data.roomorder && state.currentRoom.state === data.state && state.currentRoom.card === data.card) return false;

      state.currentRoom.roomno = data.roomno;
      state.currentRoom.roomorder = data.roomorder;
      state.currentRoom.state = data.state;
      state.currentRoom.shoe = data.shoe;
      state.currentRoom.initial = data.initial

      state.currentRoom.result = data.result;
      state.currentRoom.timer = data.timer || 0;
      state.currentRoom.timerdate = data.date || '';

      if (data.card && data.state !== 3) {
        state.currentRoom.card = data.card;
      }

      if(data.state === 3) {
        state.currentRoom.card = data.card || [
          { type: 'player', cards: [], score: 0 },
          { type: 'cards', cards: [], score: 0 },
        ];
      }

    } catch (e) {
      return false;
    }
  },
  SET_BET_CHIPS(state, chips) {
    state.betChips = chips;
  },
  SET_BIGEYEROAD_COUNT(state, bigeyeroadcount) {
    state.bigeyeroadcount = bigeyeroadcount;
  },
  SET_SMALLROAD_COUNT(state, smallroadcount) {
    state.smallroadcount = smallroadcount;
  },
  SET_COCKROACHROAD_COUNT(state, croadcount) {
    state.croadcount = croadcount;
  },
  SET_SELECTEDCHIP(state, chip) {
    state.selectedchip = chip;
  },
  SET_BULL_BET(state, bet) {
    state.bet = bet;
  },
};
